export default __webpack_public_path__ + "static/media/img-0109-canada-full-face.dc8228ef.png";